import React from 'react'
import i18n from 'live/services/i18n';
import styled from 'styled-components';

type IProps = {
    title: string,
    values?: {color: string, value: string}[]
}

export const Legends = ({title, values = []}: IProps) => {
    return <Wrapper>
        <div className='legends-wrapper-title'>{i18n('Legend')}: 
            <span className="legends-title">{title}</span>
        
        </div>

        <div className='legends-itens'>
            {
                values.map(({color, value}) => {
                    return <div className='legends-item'>
                                <div className="legends-values-container-color" style={{background: color}}> </div>
                                <div className='legends-values-value'> {value} </div>
                           </div>
                })
            }
        </div>
    </Wrapper>
}

const Wrapper = styled.div`
    padding: 16px;
    border-radius: 3px;
    background: ${({theme}) => theme['gray-0']};
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.10);

    .legends-wrapper-title{
        color: ${({theme}) => theme['gray-700']};
        font-family: ${({theme}) => theme['font-semibold']};
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 14px; 
    }


    .legends-title{
        margin-left: 8px;
        color: ${({theme}) => theme['gray-800']};
    }

    .legends-itens{
        display: flex;
        margin-top: 13px;
    }

    .legends-item{
        display: flex;
        margin-right: 24px;
    }


    .legends-values-container-color{
        border-radius: 2px;
        width: 14px;
        height: 14px;
        margin-right: 8px;
    }

    .legends-values-value{
        color: ${({theme}) => theme['gray-700']};
        font-family: ${({theme}) => theme['font-semibold']};
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
`